<template>
  <public-form />
</template>

<script>
// import createForm from '@/components/forms/orders/createOrder';
import publicForm from "@/components/forms/orders/publicOrder";

export default {
  name: "order",
  components: {
    publicForm
  }
};
</script>